export const FORCE_PAGE_RELOAD = 'APP/FORCE_PAGE_RELOAD';
export const FORCE_PAGE_RELOAD_SUCCESS = 'APP/FORCE_PAGE_RELOAD_SUCCESS';

export const APPLICATION_LOADED = 'APP/LOADED/SUCCESS';
export const APPLICATION_LOADED_FAILED = 'APP/LOADED/FAILED';

export const APPLICATION_IS_READY = 'APP/STARTED/READY';

export const CONNECTION_LOST = 'APP/CONNECTION/LOST';
export const CONNECTION_ESTABLISHED = 'APP/CONNECTION/ESTABLISHED';

export const FETCH_APP_CONFIGURATION = 'APP/CONFIGURATION/FETCH';
export const FETCH_APP_CONFIGURATION_SUCCESS = 'APP/CONFIGURATION/SUCCESS';
export const FETCH_APP_CONFIGURATION_FAILURE = 'APP/CONFIGURATION/FAILURE';

export const SET_BROWSER_NOTIFICATION_COMPATIBILITY = 'APP/NOTIFICATIONS/SET_IS_COMPATIBLE';

export const GENERATE_QR_CODE = 'APP/GENERATE/QR_CODE';

export const CHECK_VERSION_REQUEST = 'APP/CHECK_VERSION/REQUEST';
export const CHECK_VERSION_SUCCESS = 'APP/CHECK_VERSION/SUCCESS';
export const CHECK_VERSION_FAILURE = 'APP/CHECK_VERSION/FAILURE';

export const SCROLL_INTO_VIEW = 'APP/SCROLL/SCROLL_INTO_VIEW';

export const OPEN_CONCURRENCY_MODAL = 'APP/CONCURRENCY/MODAL/OPEN';
export const CLOSE_CONCURRENCY_MODAL = 'APP/CONCURRENCY/MODAL/CLOSE';
export const CONCURRENCY_REFRESH_PAGE = 'APP/CONCURRENCY/MODAL/REFRESH';

export const ANONYMOUS_REQUEST = 'APP/ANONYMOUS/REQUEST';

export const GET_FUEL_TYPES = 'APP/GET_FUEL_TYPES_REQUEST';
export const FETCH_FUEL_TYPE_SUCCESS = 'APP/GET_FUEL_TYPES_SUCCESS';

export const FETCH_HEALTH_CHECK = 'APP/FETCH_HEALTH_CHECK_REQUEST';
export const FETCH_HEALTH_CHECK_SUCCESS = 'APP/FETCH_HEALTH_CHECK_SUCCESS';
export const FETCH_HEALTH_CHECK_FAILURE = 'APP/FETCH_HEALTH_CHECK_FAILURE';

export const FETCH_THEMES = 'APP/FETCH_THEMES/REQUEST';
export const FETCH_THEMES_SUCCESS = 'APP/FETCH_THEMES/SUCCESS';

export const BLOCK_LOCATION_CHANGE = 'APP/BLOCK/LOCATION_CHANGE';
export const UNBLOCK_LOCATION_CHANGE = 'APP/UNBLOCK/LOCATION_CHANGE';

export const FETCH_SELF_SERVICE_WORKFLOW = 'APP/FETCH_SELF_SERVICE_WORKFLOW/REQUEST';
export const FETCH_SELF_SERVICE_WORKFLOW_SUCCESS = 'APP/FETCH_SELF_SERVICE_WORKFLOW/SUCCESS';
